<template>
    <div>
         <el-row>
            <el-col :span="24">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item>组织机构</el-breadcrumb-item>
                </el-breadcrumb>
            </el-col>
        </el-row>
        <el-divider></el-divider>
        <!-- <el-row>
            <el-col :span="24" style="text-align:left;">
                
            </el-col>
        </el-row> -->
        <el-row>
            <el-col :span="12">
                <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
                    <el-menu-item index="1">部门树</el-menu-item>
                    <el-menu-item index="5">父级部门</el-menu-item>
                    <el-menu-item index="2">钉钉部门</el-menu-item>
                    <el-menu-item index="3">邮箱部门</el-menu-item>
                    <el-menu-item index="4">企业微信部门</el-menu-item>
                </el-menu>
                <el-container >
                    <el-aside style="width:100%;">                        
                        <div style="width:100%;text-align:left;">
                            <el-input style="margin-bottom:12px;margin-top:12px;width:85%;margin-right:1%;" size="small"  placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
                            <el-button type="primary" :class="index==1?'':'hidden'" size="small" @click="addFrame" plain>新增机构</el-button>
                        </div>

                        <el-tree class="filter-tree" :data="data" v-loading="loading" :props="defaultProps" node-key="id" @node-click="handleNodeClick" :filter-node-method="filterNode" ref="tree">
                            <span class="custom-tree-node" slot-scope="{ node, data }">
                                <span style="font-size:14px;height:40px;">{{ node.label }}</span>
                                <span :class="node.disabled==1?'hidden':(isDelete?'':'hidden')" style="margin-left:10px;">
                                    <el-button
                                        type="text"
                                        size="mini"
                                        @click="() => remove(node, data)">
                                        删除
                                    </el-button>
                                </span>
                            </span>
                        </el-tree>
                    </el-aside>
                </el-container>
            </el-col>
            <!-- <el-col :span="4" style="height:60px;line-height:60px;text-align: left;">
                <el-button type="primary" size="small" @click="addFrame" plain>新增机构</el-button>
            </el-col> -->
            <el-col :span="10" :class="this.isShow?'':'hidden'" style="margin-left:60px;">
                <h1>编辑机构</h1>
                <el-form :model="frameModel" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                    <el-form-item label="父级部门" prop="name">
                        <el-input disabled @click.native="parentFrame" v-model="frameModel.ParentName"></el-input>
                    </el-form-item>
                    <el-form-item style="text-align:left;" label="级别" prop="region">
                        <el-select v-model="frameModel.Level" @change="selectGet" placeholder="请选择级别">
                        <el-option label="无" value=""></el-option>
                        <el-option v-for="v in frameList" :label="v.ClassName" :key="v.Id"  :value="v.Id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="机构名称" prop="name">
                        <el-input  v-model="frameModel.ClassName"></el-input>
                    </el-form-item>
                    <el-form-item label="钉钉部门" prop="name">
                        <el-input disabled @click.native="dingFrame" v-model="frameModel.DingDepartMentName"></el-input>
                    </el-form-item>
                    <el-form-item label="邮箱部门" prop="name">
                        <el-input disabled @click.native="tecentMailFrame" v-model="frameModel.TecentMailDepartMentName"></el-input>
                    </el-form-item>
                    <el-form-item label="企业微信部门" prop="name">
                        <el-input disabled @click.native="weChatFrame" v-model="frameModel.EnterpriseWeChatDepartmentName"></el-input>
                    </el-form-item>
                    <el-form-item label="负责人" prop="name">
                        <el-input v-model="frameModel.TrueName"></el-input>
                    </el-form-item>
                    <el-form-item label="负责人工号" prop="name">
                        <el-input v-model="frameModel.UserCode"></el-input>
                    </el-form-item>
                    <el-form-item style="text-align:left;" label="部门类型" prop="region">
                        <el-select v-model="frameModel.FrameType" placeholder="请选择部门类型">
                        <el-option label="无" value=""></el-option>
                        <el-option label="职能部门" value="0"></el-option>
                        <el-option label="业绩部门" value="1"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item style="text-align:left;" label="公司" prop="region">
                        <el-select v-model="frameModel.Sflag" placeholder="请选择公司">
                        <el-option label="网络科技" value="hn"></el-option>
                        <el-option label="浙江锐旗" value="zj"></el-option>
                        <el-option label="大河全媒体" value="dh"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="submitForm(frameModel)">提交</el-button>
                        <!-- <el-button @click="resetForm(frameModel)">取消</el-button> -->
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
    </div>
</template>

<script>
  import { GetWikiNodeAndArticle,GetSingleKnowledge,GetKnowledgeContentDescry  } from "../../until/ZeusApiSDK/Logic/WikiLogic";
  import { ImageAddDomain  } from "../../until/ZeusApiSDK/Logic/ImageStr";
  import { Decrypt } from "../../until/ZeusApiSDK/Logic/CryptoLogic";  
  import {EnqueueFrame} from '../../until/ZeusApiSDK/Logic/LogLogic';
  import {GetFrameAndUserTreeList,GetFrameTreeList,GetFrameInfo,InsertFrameInfo,GetItem,DeleteFrame,GetDingFrameTreeList,GetTecentMailFrameTreeList,GetWeChatFrameTreeList} from "../../until/ZeusApiSDK/Logic/Frame";
  export default {
    watch: {
      filterText(val) {
        this.$refs.tree.filter(val);
      }
    },
    created() {
        //获取当前用户
        this.getCurrentUser();
        //获取部门节点信息
        this.getFrameAndUserNode(1);
    },
    methods: {
      filterNode(value, data) {
        if (!value) return true;
        return data.label.indexOf(value) !== -1;
      },
      //获取树状结构列表
      getFrameAndUserNode:async function(index){
        if(index==2){
            this.loading=true;
            //获取钉钉部门
            await GetDingFrameTreeList().then(res=>{
                this.loading=false;
                this.data=JSON.parse(res);
            });
            return false;
        }
        else if(index==3){
            this.loading=true;
            //获取邮箱部门
            await GetTecentMailFrameTreeList().then(res=>{
                this.loading=false;
                this.data=JSON.parse(res);
            });
            return false;
        }
        else if(index==4){
            this.loading=true;
            //获取企业微信部门
            await GetWeChatFrameTreeList().then(res=>{
                this.loading=false;
                this.data=JSON.parse(res);
            });
            return false;
        }
        else if(index==5){
            this.loading=true;
            //获取部门信息
            await GetFrameTreeList().then(res=>{
                this.loading=false;
                this.data=JSON.parse(res);
            });
            return false;
        }
        else{
            this.loading=true;
            this.isDelete=true;
            //获取部门和人员信息
            await GetFrameAndUserTreeList().then(res => {
                this.loading=false;
                this.data=JSON.parse(res);
            });
            return false;
        }
      },
      selectGet:async function(vId){
        let obj = {};
        obj = await this.frameList.find((item)=>{//这里的userList就是上面遍历的数据源
            if(item.Id == vId){
                this.leaveName=item.ClassName;
            }
        });
      },
      //节点点击事件
      handleNodeClick(data){
        if(data.type=="0"){
            if(this.index=='1'){
                //当前点击为部门
                this.isShow=true;
                GetFrameInfo(data.id).then(res=>{
                    this.frameModel=res;
                    this.oldFrameModel=res;
                    this.frameModel.FrameType=this.frameModel.FrameType==0?'职能部门':'业绩部门';
                    //获取sysitem数据
                    GetItem(2).then(data=>{
                        this.frameList=data;
                    });
                });
            }
            else if(this.index=='2'){
                //钉钉部门
                //当前点击为部门
                this.isShow=true;
                this.frameModel.DingId=data.Id;
                this.frameModel.DingDepartMentName=data.label;
            }
            else if(this.index=='3'){
                //邮箱部门
                //当前点击为部门
                this.isShow=true;
                this.frameModel.TecentMailId=data.Id;
                this.frameModel.TecentMailDepartMentName=data.label;
                this.frameModel.TecentMailIdStr=data.Id;
            }
            else if(this.index=='4'){
                //企业微信部门
                //当前点击为部门
                this.isShow=true;
                this.frameModel.EnterpriseWeChatDepartmentId=data.Id;
                this.frameModel.EnterpriseWeChatDepartmentName=data.label;
            }
            else if(this.index=='5'){
                //父级部门
                //当前点击为部门
                this.isShow=true;
                this.frameModel.ParentId=data.Id;
                this.frameModel.ParentName=data.label;
            }
        }
        else{
            //当前点击为人
            this.isShow=false;
        }
      },
      //tag页面索引
      handleSelect:function(key, keyPath){
          this.isDelete=false;
          this.index=key;
          this.loading=true;
          this.getFrameAndUserNode(key);
      },
      //点击父级部门禁用框
      parentFrame:function(){
          this.loading=true;
          this.activeIndex='5';
          this.index='5';
          //显示右边部门信息
          this.isDelete=false;
          this.isShow=true;
          //获取部门节点信息
          this.getFrameAndUserNode(5);
      },
      //点击钉钉部门禁用框
      dingFrame:function(){
          this.loading=true;
          this.activeIndex='2';
          this.index='2';
          //显示右边部门信息
          this.isDelete=false;
          this.isShow=true;
          //获取部门节点信息
          this.getFrameAndUserNode(2);
      },
      //点击邮箱部门禁用框
      tecentMailFrame:function(){
          this.loading=true;
          this.activeIndex='3';
          this.index='3';
          //显示右边部门信息
          this.isDelete=false;
          this.isShow=true;
          //获取部门节点信息
          this.getFrameAndUserNode(3);
      },
      //点击企业微信部门禁用框
      weChatFrame:function(){
          this.loading=true;
          this.activeIndex='4';
          this.index='4';
          //显示右边部门信息
          this.isDelete=false;
          this.isShow=true;
          //获取部门节点信息
          this.getFrameAndUserNode(4);
      },
      //获取当前用户
      getCurrentUser:function(){
            var userinfo = window.sessionStorage.getItem("userinfo");
            userinfo = JSON.parse(Decrypt(userinfo));
            this.currentUser = userinfo;
       },
      //提交部门信息
      submitForm:function(frameModel){
        frameModel.FrameType=frameModel.FrameType=='业绩部门'?1:(frameModel.FrameType=='职能部门'?0:frameModel.FrameType);
        frameModel.LevelName=this.leaveName==''?frameModel.LevelName:this.leaveName;
        //提交部门信息
        InsertFrameInfo(frameModel).then(res=>{
            if(res){
                //编辑部门信息成功，添加日志
                EnqueueFrame("编辑部门信息frame",
                    this.currentUser.UserId,
                    this.currentUser.TrueName,
                    "编辑",
                    '更新成功',
                    frameModel.Id,
                    frameModel,
                    this.oldFrameModel,
                    "frameInfo");
                    
                this.isShow=false;
                this.getFrameAndUserNode(1);
            }
            
        });
        
      },
      //删除当前部门
      remove:function(node,data){
        this.isShow=false;
        this.$confirm('确定删除该部门吗', '删除', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
        }).then(() => {
            //删除数据
            DeleteFrame(node.key).then(res=>{
                if(res){
                    //删除部门信息成功，添加日志
                    EnqueueFrame("删除部门信息frame",
                        this.currentUser.UserId,
                        this.currentUser.TrueName,
                        "删除",
                        '删除成功',
                        this.oldFrameModel.Id,
                        {},
                        this.oldFrameModel,
                        "frameInfo");
                        
                    this.activeIndex='1';
                    this.index='1';
                    //获取部门节点信息
                    this.getFrameAndUserNode(1);
                }else{
                    alert('删除失败，此分类下有子类或用户');
                }
            });
        }).catch(() => {
            //取消    
        });
      },
      //新增机构 跳转到添加页面
      addFrame:function(){
          this.$router.push('/Organization/AddFrame');
      }
    },

    data() {
      return {
        wiki:{},
        currentUser:{},
        content:'',
        filterText: '',
        isShow:false,
        isFrameShow:false,
        isDelete:false,
        loading:true,
        index:1,//当前部门索引
        frameList:[],
        leaveName:'',
        data:[],
        frameModel:{},//新部门信息
        oldFrameModel:{},//旧部门信息
        activeIndex:'1',//menu页索引
        defaultProps: {
          children: 'children',
          label: 'label',
          disabled:'type'
        }
      };
    }
  };
</script>
<style lang="less" scoped>
.darkTag{
    margin-left: 10px;
    margin-right: 3px;
}
.show{
    display: block;
}
.hidden{
    display: none;;
}
</style>